<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light bg-white">
      <div class="container">
        <router-link :to="{ name: logoRedirection, params: user ? { id: user.id } : {} }" class="navbar-brand">
          <Logo />
        </router-link>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false">
          <span class="navbar-toggler-icon"/>
        </button>

        <div id="navbarToggler" class="collapse navbar-collapse">
          <ul class="navbar-nav">
            <locale-dropdown/>
          </ul>

          <ul class="navbar-nav ml-auto">
            <!-- Authenticated -->
            <li v-if="user" class="nav-item dropdown">
              <a class="nav-link dropdown-toggle text-dark" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ user.nick_name }}
              </a>
              <div class="dropdown-menu">
                <router-link :to="{ name: 'settings.profile', params: {id: this.user.id} }" class="dropdown-item pl-3">
                  <fa icon="cog" fixed-width/>
                  {{ $t('profile.title') }}
                </router-link>

                <div v-if="hasAccessToManagePanel()" class="dropdown-divider"/>
                <router-link v-if="hasAccessToManagePanel()" :to="managePanelLink" class="dropdown-item pl-3" @click.prevent="backToManagePanel()">
                  <fa icon="toolbox" fixed-width/>
                  {{ $t('manage_panel') }}
                </router-link>

                <div v-if="isRecipient(user)" class="dropdown-divider"/>
                <router-link v-if="isRecipient(user)" :to="{ name: 'settings.evaluations', params: {id: this.user.id}}" class="dropdown-item pl-3">
                  <fa icon="toolbox" fixed-width/>
                  {{ $t('evaluation.evaluations') }}
                </router-link>

                <div class="dropdown-divider"/>
                <a href="#" class="dropdown-item pl-3" @click.prevent="logout">
                  <fa icon="sign-out-alt" fixed-width/>
                  {{ $t('logout') }}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LocaleDropdown from './LocaleDropdown'
import { isRecipient, isProfessional, isManager, isOrganizationLeader, isAdmin } from '~/plugins/auth'

export default {
  components: {
    LocaleDropdown
  },

  data: () => ({
    appName: window.config.appName
  }),

  computed: {
    logoRedirection () {
      if (isAdmin(this.user)) {
        return 'manage.organizations'
      }

      if (isOrganizationLeader(this.user)) {
        return 'manage.license'
      }

      if (isProfessional(this.user) || isManager(this.user)) {
        return 'manage.recipients'
      }

      if (this.user) {
        return 'settings.profile'
      }

      return 'welcome'
    },

    managePanelLink: function () {
      if (isProfessional(this.user) || isManager(this.user)) { return { name: 'manage.recipients' } }
      return { name: 'manage.users' }
    },
    ...mapGetters({
      user: 'auth/user'
    })
  },

  methods: {
    isRecipient (user) {
      return isRecipient(user)
    },

    async logout () {
      // Log out the user.
      await this.$store.dispatch('auth/logout')

      // Redirect to login.
      this.$router.push({ name: 'welcome' })
    },

    hasAccessToManagePanel () {
      return !isRecipient(this.user)
    }
  }
}
</script>

<style scoped>
.logo {
  height: 24px;
  fill: #333;
  margin-top: 0.3rem;
}

.profile-photo {
  width: 2rem;
  height: 2rem;
  margin: -.375rem 0;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/Navbar.vue